// extracted by mini-css-extract-plugin
export default {"form":"HeaderForm_form__0+OLw","grid":"HeaderForm_grid__p2wya","formLabel":"HeaderForm_formLabel__U+HpP","specialGridItem":"HeaderForm_specialGridItem__d4Bma"};